import type { SVGProps } from 'react';

/** Figma `metric-formant.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const MetricFormantIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame">
      <path
        id="Vector"
        d="M9.00035 1.63672L11.0458 6.70945L16.364 7.11854L12.2731 10.6367L13.5822 15.8731L9.00035 13.0094L4.41854 15.8731L5.72763 10.6367L1.63672 7.11854L6.9549 6.70945L9.00035 1.63672Z"
        stroke="#E58C1A"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
